import styled from 'styled-components';
import { theme } from '../styles/Theme';

export const Jumbotron = styled.div`
  background: url(${props => props.background}) no-repeat top left;
  background-position-y: top;
  background-size: cover;
  color: #fff;
  position: relative;

  @media screen and (min-width: 768px) and (max-width: 1140px) {
    background: url(${props => props.background}) no-repeat center left;
    background-size: cover;
  }

  @media screen and (min-width: 1141px) {
    background: url(${props => props.background}) no-repeat center right;
    background-size: cover;
  }
`;

export const Hero = styled.div`
  background-color: rgba(0, 0, 0, 0.55);
  color: #fff;
  text-align: left;

  .container {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    max-width: 1400px;

    .copy {
      flex-basis: 100%;
      padding: 3rem 1rem;
      text-align: center;

      h1 {
        color: #fff;
      }

      h2 {
        color: #fff;
        margin-bottom: 21px;
        text-align: center;
      }

      p {
        color: #fff;
        font-weight: 300;
        margin-bottom: 21px;
      }

      button {
        width: 100%;
        font-size: 22px;

        @media screen and (max-width: 768px) {
          font-size: 18px;
        }
      }

      @media screen and (max-width: 1400px) {
        padding: 70px;
      }
    }
  }

  @media screen and (min-width: 768px) and (max-width: 1140px) {
    background-color: transparent;
  }

  @media screen and (min-width: 1141px) {
    background-color: transparent;

    .container {
      justify-content: space-between;
      padding: 0 4rem 1rem;

      .copy {
        flex-basis: 40%;
        padding: 7rem 0;
        text-align: left;

        h2 {
          text-align: left;
        }
      }
    }
  }

  @media screen and (min-width: 1600px) {
    background-color: transparent;
    padding-top: 10rem 0;
  }
`;

export const Modal = styled.div`
  background: rgba(255, 255, 255, 1);
  bottom: 0;
  color: white;
  display: ${props => (props.isModalOpen ? 'block' : 'none')};
  flex-basis: 100%;
  height: 100%;
  left: 10px;
  margin-top: 1rem;
  position: absolute;
  right: 10px;
  top: 35px;
  z-index: 1;

  .modal-body {
    background-color: #fff;
    border: 1px solid lightgrey;
    padding: 20px;

    .close {
      cursor: pointer;
      position: absolute;
      right: 2%;
      top: 2%;
      transition: 0.2s color ease-in-out;

      &:hover {
        color: ${theme.primary};
      }
    }

    h3 {
      color: #00000099;
      font-weight: 400;
      margin-bottom: 0;
      text-align: center;
    }

    .subtitle {
      color: #00000099;
      font-weight: 400;
      margin-bottom: 1.5rem;
      text-align: center;
    }

    form {
      .invalid-feedback {
        display: block;
        min-height: 20px;
      }

      textarea.form-control {
        padding: 1.3rem 0.5rem 0.4rem;
      }

      .submit {
        margin: 1.5rem 0;
      }

      .small {
        color: #00000099;
        font-size: 0.875rem;
        text-align: center;
      }

      .text-center {
        text-align: center;

        .submit-error {
          color: red;
        }
      }
    }

    .thanks-wrapper {
      align-items: center;
      display: flex;
      flex-direction: column;
      justify-content: center;

      p {
        color: #00000099;
      }
    }
  }

  @media screen and (min-width: 768px) and (max-width: 1140px) {
    left: 10%;
    margin-top: 1rem;
    top: 10%;
    right: 10%;
  }

  @media screen and (min-width: 1141px) {
    flex-basis: 55%;
    margin-top: 0;
    position: initial;
  }
`;

export const ContentWrapper = styled.div`
  padding: 1rem 0;

  .container {
    padding: 0 2rem;

    .filter-row {
      align-items: center;
      display: flex;
      justify-content: space-around;
      margin-top: 1rem;
      padding: 0 15px;

      h2 {
        color: #000000de;
        font-size: 30px;
        font-weight: 300;
        margin-bottom: 1rem;
        text-align: center;
      }

      .dropdown {
        .dropdown-menu {
          .dropdown-item {
            cursor: pointer;
          }
        }
      }
    }

    .partner-wrapper {
      display: flex;
      flex-wrap: wrap;
      justify-content: start;
      margin: 2rem -15px 0 -15px;

      .card-div {
        align-items: center;
        border: 1px solid transparent;
        border-radius: 5px;
        flex-basis: 100%;
        margin: 15px;

        .card {
          display: flex;
          flex-basis: 100%;
          flex-direction: column;
          height: 100%;
          padding: 2rem 2rem 0.5rem 2rem;
          text-decoration: none;

          img {
            display: block;
            margin: 0 auto 3rem;
            height: 35px;
            width: auto;
          }

          .copy {
            flex-grow: 1;
            margin-bottom: 0;

            .name {
              color: #00000099;
              font-weight: 700;
              margin-bottom: 0;
            }

            .description {
              color: #00000099;
              font-weight: 300;
              line-height: 1.5;
            }
          }

          .learn-more {
            align-self: flex-end;

            span {
              text-decoration: none;
            }
          }
        }

        &:hover {
          box-shadow: 0px 0px 6px #2260B2;
          border: 1px solid #2260b2;
          text-decoration: none;
        }

        @media screen and (min-width: 768px) {
          flex-basis: calc((100% / 2) - 30px);
        }

        @media screen and (min-width: 992px) {
          flex-basis: calc((100% / 3) - 30px);
        }
      }
    }

    @media screen and (min-width: 992px) {
      max-width: 1410px;
    }
  }

  @media screen and (min-width: 768px) and (max-width: 1140px) {
    padding: 4rem 0;

      .partner-wrapper {
        margin: 4rem -15px 0 -15px;
      }
    }
  }

  @media screen and (min-width: 1200px) {
    .container {
      .filter-row {
        h2 {
          margin-bottom: 0;
          margin-right: auto;
        }
      }
    }
  }

  .Nav {
    .card {
      img {
        height: 110px !important;
        margin: 0 auto !important;
        position: relative;
        top: -30px;
      }
    }
  }
`;
